module.exports = __webpack_public_path__ + "img/start01.293c3102.webp";